module.exports = __webpack_public_path__ + "static/NFNLogo-809af362a9f7bc943301a7ba7ea43a3e.png";